export default {
    publicKeyAPI  : null,
    servicekey : null,
    secretKey : null
}
